import React from "react";
import { render } from "react-dom";
import FavouriteCounter from "./app/FavouriteCounter";


render(
  <FavouriteCounter/>
  ,
  document.getElementById("favourite-counter")
);
